/**
 * PageHeader: title on the left, back link on the right.
 * Pass `section` to link back to that flywheel area, or `backTo` for a specific path.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { sectionBackProps } from '../config/permissions';
import './PageHeader.css';

const PageHeader = ({ title, backTo, backLabel, section, children }) => {
  const fromSection = section ? sectionBackProps(section) : null;
  const to = backTo ?? fromSection?.backTo;
  const label = backLabel ?? fromSection?.backLabel ?? '← Home';

  return (
    <div className="page-header">
      <div className="page-header-row">
        <h1 className="page-header-title">{title}</h1>
        {to && (
          <Link to={to} className="page-header-back">
            {label}
          </Link>
        )}
      </div>
      {children}
    </div>
  );
};

export default PageHeader;
